const reset = ({subtype, target}) => ({
    type: `RESET_${subtype}`,
    target
});
  
export {
    reset,
}
  